import TypeWeight from './TypeWeight';

export default TypeWeight;
